console.log("🧑‍🍼");
let configuratorIsOpen = false;
const LUIER_TYPE = "luiers";
const EXTRA_TYPE = "extra";

// check if safari
const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
if (isSafari) {
  document.body.classList.add("safari");
}

const oodConfigurator = window.oodConfigurator || {};
oodConfigurator.basket = [];
oodConfigurator.child = {};
oodConfigurator.addToBasket = (
  productId,
  variantId,
  amount,
  price,
  image,
  title,
  variantName,
  type,
  subscription,
  color,
  amountOfDiapers,
  diapersSize
) => {
  // todo check if product is already in basket
  const existingProduct = oodConfigurator.basket.find(
    (item) =>
      item.productId === productId &&
      item.variantId === variantId &&
      item.type === type
  );
  if (type === LUIER_TYPE) {
    // remove all existing luiers from basket
    oodConfigurator.basket = oodConfigurator.basket.filter(
      (item) => item.type !== LUIER_TYPE
    );
  }
  if (type === EXTRA_TYPE) {
    // remove products with same product ID that are also type extra
    oodConfigurator.basket = oodConfigurator.basket.filter((item) => {
      console.log(
        "adding",
        item.productId,
        item.variantId,
        item.type,
        productId
      );
      if (
        item.type === EXTRA_TYPE &&
        item.productId === productId &&
        item.variantId !== variantId
      ) {
        return false;
      }
      return true;
    });
  }
  if (existingProduct) {
    console.log("EXITINSTIN GPRODUCT", amount);
    existingProduct.amount = amount;
    existingProduct.subscription = subscription;
    return;
  }
  oodConfigurator.basket.push({
    productId,
    variantId,
    amount,
    price,
    image,
    title,
    variantName,
    type,
    subscription,
    color,
    amountOfDiapers,
    diapersSize,
  });
};

oodConfigurator.removeFromBasket = (productId, variantId) => {
  oodConfigurator.basket = oodConfigurator.basket.filter((item) => {
    if (item.type === LUIER_TYPE) {
      return true;
    }
    return item.productId !== productId || item.variantId !== variantId;
  });
};

oodConfigurator.showTotalPrice = () => {
  const priceElements = document.querySelectorAll(".basketPrice");
  const totalPrice = oodConfigurator.basket.reduce((acc, item) => {
    // if subscription give 10% discount
    if (item.subscription) {
      return acc + item.price * item.amount * 0.9;
    }
    return acc + item.price * item.amount;
  }, 0);
  const formatedPrice = new Intl.NumberFormat("nl-BE", {
    style: "currency",
    currency: "EUR",
  }).format(totalPrice / 100);

  priceElements.forEach((element) => {
    element.innerHTML = formatedPrice;
  });
};

oodConfigurator.selectChild = (
  childImageUrl,
  childName,
  dateOfBirth,
  postcode,
  childImageId
) => {
  oodConfigurator.child.childImageUrl = childImageUrl;
  oodConfigurator.child.childImageId = childImageId;
  oodConfigurator.child.childName = childName;
  oodConfigurator.child.dateOfBirth = dateOfBirth;
  oodConfigurator.child.postcode = postcode;
  const childImages = document.querySelectorAll(".selectedChildAvatar img");
  childImages.forEach((image) => {
    image.src = childImageUrl;
  });
  const childNames = document.querySelectorAll(".selectedChildName");
  childNames.forEach((name) => {
    name.innerHTML = childName;
  });
};

oodConfigurator.renderOverview = () => {
  const diaperlist = document.getElementById("diaperlist");
  const extrasList = document.getElementById("extrasList");

  const chosenSellingPlanButton = document.querySelector(
    ".ood-levering-button-grid button.active"
  );
  const frequency = chosenSellingPlanButton.dataset.frequency;

  diaperlist.innerHTML = "";
  extrasList.innerHTML = "";

  oodConfigurator.basket.forEach((item) => {
    if (item.type === LUIER_TYPE) {
      diaperlist.innerHTML += `<li>
        <span class="variantBadge" style="background: ${item.color || "red"}">${
        item.variantName || 5
      }</span>
        <img src="${item.image}" alt="${item.title}" />
    

      <div class="productText">


        <h4> <b>${item.title}</b> maat ${item.variantName}</h4>
        <p>${item.amountOfDiapers} stuks ${item.diapersSize}<br/>(€${(
        (item.amount * item.price * 0.9) /
        100 /
        parseInt(item.amountOfDiapers)
      )
        .toFixed(2)
        .replace(".", ",")} per stuk)<br/>Elke ${frequency} weken</p>
        
      </div>

      <div class="pricey">
       ${new Intl.NumberFormat("nl-BE", {
         style: "currency",
         currency: "EUR",
       }).format((item.amount * item.price * 0.9) / 100)}
      </div>
    </li>`;
    }

    if (item.type !== LUIER_TYPE) {
      extrasList.innerHTML += `<li>
        <img src="${item.image}" alt="${item.title}" />
    
      <div class="productText">
        <h4>${item.amount} x ${item.title} ${
        item.variantName == "Default Title" ? "" : "(" + item.variantName + ")"
      }</h4>
        <p>${item.subscription ? `Elke ${frequency} weken` : "Eénmalig"}</p>
      </div>

      <div class="pricey">
       ${new Intl.NumberFormat("nl-BE", {
         style: "currency",
         currency: "EUR",
       }).format(
         item.subscription
           ? (item.amount * item.price * 0.9) / 100
           : (item.amount * item.price) / 100
       )}
      </div>
    </li>`;
    }
  });
  // check if no extra itesm
  const extrasListHeader = document.querySelector(".ood-bestel-header-extras");
  if (extrasList.innerHTML === "") {
    extrasList.innerHTML = `<li class="no-extra-products">
        
          <h4>Geen extra producten</h4>
        
      </li>`;

    if (extrasListHeader) {
      extrasListHeader.style.display = "none";
    }
  } else {
    if (extrasListHeader) {
      extrasListHeader.style.display = "flex";
    }
  }

  // check if no diapers itesm
  if (diaperlist.innerHTML === "") {
    diaperlist.innerHTML = `<li>
          
            <h4>Geen box</h4>
          
        </li>`;
  }
};

const parentSelector = document.querySelectorAll(".child-selector li");

const observer = new IntersectionObserver(
  (entries, observer) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        // Only do the observer if the viewport is small enough so we don't have multiple active elements
        // fallback is clicking the element with will always work.
        if (window.innerWidth < 477) {
          entry.target.classList.add("active");
        }
      } else {
        if (window.innerWidth < 477) {
          entry.target.classList.remove("active");
        }
      }
    });
  },
  {
    threshold: 1,
  }
);

// loop through each ul element and observe it

parentSelector.forEach((parent) => {
  //check if viewport is smaller than 768px
  observer.observe(parent);

  parent.addEventListener("click", (e) => {
    parentSelector.forEach((parent) => {
      parent.classList.remove("active");
    });
    parent.classList.add("active");

    // scroll into center

    parent.scrollIntoView({
      behavior: "smooth",
      block: "center",
      inline: "center",
    });
  });
});

// get all li elements with class child-selector
const childSelector = document.querySelectorAll(".child-selector");

const childFormPage1 = document
  .getElementById("childForm")
  ?.addEventListener("submit", (e) => {
    e.preventDefault();
    const childName = document.getElementById("childName").value;
    const childImage = document.querySelector(
      ".child-selector li.active img"
    ).src;
    const childImageId = document.querySelector(".child-selector li.active img")
      .dataset.image;

    const dateOfBirth = document.getElementById("dateOfBirth").value;
    const postcode = document.getElementById("zip").value;

    oodConfigurator.selectChild(
      childImage,
      childName,
      dateOfBirth,
      postcode,
      childImageId
    );

    goToPage("ood-page2", "checkPostcode");
  });

const infoMultipleChildren = document.querySelectorAll(
  ".info-multiple-children-button"
);
for (let index = 0; index < infoMultipleChildren.length; index++) {
  const element = infoMultipleChildren[index];

  element.addEventListener("click", (e) => {
    element.classList.add("active");
  });
}

const closeInfoButtons = document.querySelectorAll(".close-info-button");
for (let index = 0; index < closeInfoButtons.length; index++) {
  const closeInfoButton = closeInfoButtons[index];

  closeInfoButton?.addEventListener("click", () => {
    closeInfoButton.parentElement.parentElement
      .querySelector(".info-multiple-children-button")
      .classList.remove("active");
  });
}

const closeOodNewsletterModal = document.getElementById(
  "close-ood-newsletter-modal"
);
closeOodNewsletterModal?.addEventListener("click", () => {
  document.querySelector(".modal-no-delivery").classList.remove("show");
});

const modalBg = document.querySelector(".modal-bg");
const modall = document.querySelector(".ood-modal");
const closeModallButtons = document.querySelectorAll(".close-ood-modal");
const showConfig = document.getElementById("show-config");

window.addEventListener("hashchange", function () {
  //
  if (this.location.hash.includes("#configurator")) {
    // remove this hash from url
    this.location.hash = "";
    showConfigurator();
  }
  console.log("window", this.location.hash);
});
// also trigger on first visit

const openConfigButtons = document.querySelectorAll(".open-config");
openConfigButtons.forEach((button) => {
  button.addEventListener("click", (e) => {
    e.preventDefault();
    showConfigurator();
  });
});

const closeConfigurator = () => {
  // scroll modall complete to left
  modall.scrollLeft = 0;
  modalBg.style.display = "none";
  modall.style.display = "none";
  configuratorIsOpen = false;
  const whatsappWidget = document.getElementById("whatsapp-chat-widget");
  if (whatsappWidget) {
    whatsappWidget.style.display = "block";
  }
};

const showConfigurator = () => {
  const whatsappWidget = document.getElementById("whatsapp-chat-widget");
  if (whatsappWidget) {
    whatsappWidget.style.display = "none";
  }
  modalBg.style.display = "block";
  modall.style.display = "flex";
  configuratorIsOpen = true;
};

// modalBg?.addEventListener("click", closeConfigurator);
closeModallButtons?.forEach((button) => {
  button.addEventListener("click", closeConfigurator);
});
document.addEventListener("keydown", (e) => {
  if (e.key === "Escape") {
    closeConfigurator();
  }
});
showConfig?.addEventListener("click", showConfigurator);

const gotoButtons = document.querySelectorAll(".gotoButton");
gotoButtons.forEach((button) => {
  button.addEventListener("click", (e) => {
    console.log("clikcing goto button");
    e.preventDefault();
    button.disabled = true;

    const target = e.target.dataset.target || "/";
    const action = e.target.dataset.action || "/";

    goToPage(target, action, button);
  });
});

const clickOnDiaperSubscription = () => {
  console.log("choos ediepaper subscriptoin");
  const chosenvariant = document.querySelector(".sizeChooser button.active");
  if (!chosenvariant && configuratorIsOpen) {
    alert("Gelieve een maat te selecteren");
    button.disabled = false;
    return;
  }

  const price = chosenvariant.dataset.price;
  const productId = chosenvariant.dataset.product;
  const variantId = chosenvariant.dataset.variant;
  const productName = chosenvariant.dataset.productname;
  const variantName = chosenvariant.dataset.variantname;
  const color = chosenvariant.dataset.color;
  const amountOfDiapers = chosenvariant.dataset.amount;
  const diapersSize = chosenvariant.dataset.size;
  const chosenProductImage = document.querySelector(
    ".chooseProduct button.active img"
  )?.src;
  oodConfigurator.addToBasket(
    productId,
    variantId,
    1,
    price,
    chosenProductImage,
    productName,
    variantName,
    LUIER_TYPE,
    true,
    color,
    amountOfDiapers,
    diapersSize
  );
  oodConfigurator.showTotalPrice();
};

const goToPage = (pageId, action, button) => {
  console.log("goToPage", pageId, action);
  if (action == "adddiapers") {
    //  clickOnDiaperSubscription();
  }
  if (action == "addextras") {
    const amountExtras = document.querySelectorAll(".amountExtras");
    amountExtras.forEach((extra) => {
      const productId = extra.dataset.product;
      if (parseInt(extra.innerHTML) > 0) {
        const price = extra.dataset.price;
        const variantId = extra.dataset.variant;
        const productName = extra.dataset.productname;
        const variantName = extra.dataset.variantname;
        const chosenProductImage = extra.dataset.img;
        const color = extra.dataset.color; // NOT YET SET => will be done on new page for extra diapers

        const variantCheckbox = document.getElementById("eenmalig" + productId);
        oodConfigurator.addToBasket(
          productId,
          variantId,
          extra.innerHTML,
          price,
          chosenProductImage,
          productName,
          variantName,
          "extra",
          !variantCheckbox.checked,
          color,
          0
        );
      } else {
        oodConfigurator.removeFromBasket(productId, extra.dataset.variant);
      }
      oodConfigurator.showTotalPrice();
    });
  }

  if (action == "renderOverview") {
    oodConfigurator.renderOverview();
  }

  if (action == "checkout") {
    const chosenSellingPlanButton = document.querySelector(
      ".ood-levering-button-grid button.active"
    );
    const chosenSellingPlanId = chosenSellingPlanButton.dataset.sellingplan;
    const frequency = chosenSellingPlanButton.dataset.frequency;
    items = [];
    // loop over basket and add all to cart
    oodConfigurator.basket.forEach((item) => {
      const newItem = {
        id: item.variantId,
        quantity: item.amount,
        selling_plan: item.subscription ? chosenSellingPlanId : null,
      };
      if (item.type === LUIER_TYPE) {
        newItem.properties = {
          Naam: oodConfigurator.child.childName,
          _Geboortedatum: oodConfigurator.child.dateOfBirth,
          _Postcode: oodConfigurator.child.postcode,
          _ChildImage: oodConfigurator.child.childImageId,
          _Size: item.variantName,
          _Color: item.color,
          _Frequency: frequency,
        };
      }
      items.push(newItem);
    });
    console.log(items);
    let formData = {
      items: items,
      attributes: {
        Naam: oodConfigurator.child.childName,
        Geboortedatum: oodConfigurator.child.dateOfBirth,
        Postcode: oodConfigurator.child.postcode,
        ChildImage: oodConfigurator.child.childImageId,
      },
    };
    fetch(window.Shopify.routes.root + "cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    })
      .then((response) => {
        button.disabled = false;
        window.location.href = "/checkout";
        return response.json();
      })
      .catch((error) => {
        button.disabled = false;
        console.error("Error:", error);
      });

    return;
  }

  if (action == "checkPostcode") {
    // ALL POSTCODES ARE ALLOWED
    // const postcode = document.getElementById("zip").value?.trim();
    // const allowedPostcodes = window.allowedPostcodes || ["9999"];
    // if (allowedPostcodes.includes(postcode)) {
    // } else {
    //   // save the postcode as tag on customer
    //   document.getElementById("capture-postcode").value =
    //     "postcode-" + postcode;
    //   //show popup to subscribe to newsletter.
    //   document.querySelector(".modal-no-delivery").classList.add("show");
    //   // button.disabled = false;
    //   return;
    // }
  }
  const targetElement = document.getElementById(pageId);
  console.log("targetElement", targetElement);
  if (targetElement) {
    targetElement.scrollIntoView({});
    if (button) {
      button.disabled = false;
    }
  }
};

const chooseProductButtons = document.querySelectorAll(".chooseProduct button");
const chooseProductSizes = document.querySelectorAll(".sizeChooser");
const sizeChooserButtons = document.querySelectorAll(".sizeChooser button");
chooseProductButtons.forEach((button) => {
  button.addEventListener("click", (e) => {
    // if button is already active do nothing
    if (button.classList.contains("active")) {
      return;
    }

    // add active class to the button
    chooseProductButtons.forEach((button) => {
      button.classList.remove("active");
    });
    chooseProductSizes.forEach((size) => {
      size.classList.remove("showSizes");
    });
    const clickedProductId = button.dataset.product;
    const localStorageVariant = localStorage.getItem(
      "ood-product-" + clickedProductId
    );

    sizeChooserButtons.forEach((button) => {
      button.classList.remove("active");
    });

    if (localStorageVariant) {
      const variantButton = document.querySelector(
        `[data-variant="${localStorageVariant}"]`
      );
      if (variantButton) {
        variantButton.classList.add("active");
        // scroll into view
        setTimeout(() => {
          variantButton.scrollIntoView({ behavior: "smooth" });
          setNumberOfDiapersADay();
        }, 100);
      }
    } else {
      // set first variant active
      document
        .getElementById("sizesFor" + clickedProductId)
        .querySelector(".sizeChooser button")
        ?.classList.add("active");
    }

    document
      .getElementById("sizesFor" + clickedProductId)
      .classList.add("showSizes");
    button.classList.add("active");

    // makes sure we select the new product even if we dont click on button
    clickOnDiaperSubscription();
    // check if ul has overflow.
    const buttonArrowsSizeChooser = document.querySelector(
      ".buttonArrowsSizeChooser"
    );
    const ulSize = document.querySelector("ul.sizeChooser.showSizes");
    console.log("ulSize", ulSize);

    if (ulSize) {
      if (ulSize.scrollWidth > ulSize.clientWidth) {
        buttonArrowsSizeChooser.style.display = "flex";
      } else {
        buttonArrowsSizeChooser.style.display = "none";
      }
    }
  });
});

sizeChooserButtons.forEach((button) => {
  button.addEventListener("click", (e) => {
    // add active class to the button
    sizeChooserButtons.forEach((button) => {
      button.classList.remove("active");
    });
    button.classList.add("active");
    const clickedProductId = button.dataset.product;
    const clickedVariantId = button.dataset.variant;
    const amountInBox = button.dataset.amount;
    // save to localstorage
    localStorage.setItem("ood-product-" + clickedProductId, clickedVariantId);
    // set amounts in all countNumberOfPampers elements
    setNumberOfDiapersADay();
  });
});

const setNumberOfDiapersADay = () => {
  const button = document.querySelector(".sizeChooser button.active");
  if (button) {
    const amountInBox = button.dataset.amount;

    const countNumberOfPampers = document.querySelectorAll(
      ".countNumberOfPampers"
    );

    countNumberOfPampers.forEach((element) => {
      const numberOfWeeks = parseInt(element.dataset.weeks);
      element.innerHTML = Math.floor(
        parseInt(amountInBox) / (numberOfWeeks * 7)
      );
    });
  }
};

setNumberOfDiapersADay();
const plusButtons = document.querySelectorAll(".plusButton");
const minusButtons = document.querySelectorAll(".minusButton");
const monthlyCheckboxes = document.querySelectorAll(".monthlyCheckbox");

monthlyCheckboxes.forEach((checkbox) => {
  checkbox.addEventListener("change", (e) => {
    const pricyTag =
      e.target.parentElement.parentElement.querySelector(".product-price");
    const fullPrice = pricyTag.dataset.price;
    const price = !e.target.checked ? fullPrice * 0.9 : fullPrice;
    pricyTag.innerHTML = !e.target.checked
      ? "<s>€" +
        (fullPrice / 100).toFixed(2).replace(".", ",") +
        "</s> €" +
        (price / 100).toFixed(2).replace(".", ",")
      : "€" + (price / 100).toFixed(2).replace(".", ",");

    const amountExtras = document.querySelectorAll(".amountExtras");
    amountExtras.forEach((extra) => {
      const productId = extra.dataset.product;
      if (parseInt(extra.innerHTML) > 0) {
        const price = extra.dataset.price;
        const variantId = extra.dataset.variant;
        const productName = extra.dataset.productname;
        const variantName = extra.dataset.variantname;
        const chosenProductImage = extra.dataset.img;
        const color = extra.dataset.color; // NOT YET SET => will be done on new page for extra diapers

        const variantCheckbox = document.getElementById("eenmalig" + productId);
        oodConfigurator.addToBasket(
          productId,
          variantId,
          extra.innerHTML,
          price,
          chosenProductImage,
          productName,
          variantName,
          "extra",
          !variantCheckbox.checked,
          color,
          0
        );
      } else {
        oodConfigurator.removeFromBasket(productId, extra.dataset.variant);
      }
    });

    oodConfigurator.showTotalPrice();
  });
});
plusButtons.forEach((button) => {
  button.addEventListener("click", (e) => {
    const input = button.previousElementSibling;
    input.innerHTML = parseInt(input.innerHTML) + 1;

    // calculate total amount

    const amountExtras = document.querySelectorAll(".amountExtras");
    amountExtras.forEach((extra) => {
      const productId = extra.dataset.product;
      if (parseInt(extra.innerHTML) > 0) {
        const price = extra.dataset.price;
        const variantId = extra.dataset.variant;
        const productName = extra.dataset.productname;
        const variantName = extra.dataset.variantname;
        const chosenProductImage = extra.dataset.img;
        const color = extra.dataset.color; // NOT YET SET => will be done on new page for extra diapers

        const variantCheckbox = document.getElementById("eenmalig" + productId);
        oodConfigurator.addToBasket(
          productId,
          variantId,
          extra.innerHTML,
          price,
          chosenProductImage,
          productName,
          variantName,
          "extra",
          !variantCheckbox.checked,
          color,
          0
        );
      } else {
        oodConfigurator.removeFromBasket(productId, extra.dataset.variant);
      }
    });

    oodConfigurator.showTotalPrice();
  });
});

minusButtons.forEach((button) => {
  button.addEventListener("click", (e) => {
    const input = button.nextElementSibling;
    input.innerHTML = Math.max(0, parseInt(input.innerHTML) - 1);

    const amountExtras = document.querySelectorAll(".amountExtras");
    amountExtras.forEach((extra) => {
      const productId = extra.dataset.product;
      if (parseInt(extra.innerHTML) > 0) {
        const price = extra.dataset.price;
        const variantId = extra.dataset.variant;
        const productName = extra.dataset.productname;
        const variantName = extra.dataset.variantname;
        const chosenProductImage = extra.dataset.img;
        const color = extra.dataset.color; // NOT YET SET => will be done on new page for extra diapers

        const variantCheckbox = document.getElementById("eenmalig" + productId);
        oodConfigurator.addToBasket(
          productId,
          variantId,
          extra.innerHTML,
          price,
          chosenProductImage,
          productName,
          variantName,
          "extra",
          !variantCheckbox.checked,
          color,
          0
        );
      } else {
        console.log("REMOVING FROM BAKSET");
        oodConfigurator.removeFromBasket(productId, extra.dataset.variant);
      }
    });

    oodConfigurator.showTotalPrice();
  });
});

const leveringsButtons = document.querySelectorAll(
  ".ood-levering-button-grid button"
);
leveringsButtons.forEach((button) => {
  button.addEventListener("click", (e) => {
    leveringsButtons.forEach((button) => {
      button.classList.remove("active");
    });
    button.classList.add("active");
  });
});

const extraProductsList = document.getElementById("extra-products-list");
const extraDiapersList = document.getElementById("extra-diapers-list");
const showExtraProductsList = document.getElementById(
  "show-extra-products-list"
);
const showExtraDiapersList = document.getElementById("show-extra-diapers-list");

showExtraProductsList.addEventListener("click", (e) => {
  e.preventDefault();
  extraProductsList.style.display = "block";
  extraDiapersList.style.display = "none";
});

showExtraDiapersList.addEventListener("click", (e) => {
  e.preventDefault();
  extraProductsList.style.display = "none";
  extraDiapersList.style.display = "block";
});

const allVariantSelects = document.querySelectorAll(".variant-chooser");

allVariantSelects.forEach((variantSelect) => {
  variantSelect.addEventListener("change", (e) => {
    // set e.target.value on dataset of parent parent .amountExtras
    const amountExtras =
      variantSelect.parentElement.parentElement.querySelector(".amountExtras");
    amountExtras.dataset.variant = e.target.value;

    amountExtras.dataset.variantname =
      e.target.options[e.target.selectedIndex].text;
  });
});

document
  .querySelector(".close-ood-modal-info")
  ?.addEventListener("click", () => {
    const childname = window.currentChild;
    const childOrderId = window.currentChildOrderId;
    const whatsappLink = document.getElementById("whatsappLink");
    //update href, chang ___child___ to the childname in the link
    whatsappLink.href = whatsappLink.href
      .replace(childname, "___child___")
      .replace(childOrderId, "___order___");

    document.querySelector(".ood-modal-info")?.classList.remove("show");
  });

const childrenInfoChange = document.querySelectorAll(".info-subscription");
childrenInfoChange?.forEach((child) => {
  child.addEventListener("click", (e) => {
    const childname = "*" + child.dataset.childname + "*";
    window.currentChild = childname;
    const childOrderId = child.dataset.orderid;
    window.currentChildOrderId = childOrderId;
    const whatsappLink = document.getElementById("whatsappLink");
    //update href, chang ___child___ to the childname in the link
    whatsappLink.href = whatsappLink.href.replace("___child___", childname);
    whatsappLink.href = whatsappLink.href.replace("___order___", childOrderId);

    document.querySelector(".ood-modal-info")?.classList.add("show");
  });
});

const setDescriptions = () => {
  const allVariantSelects = document.querySelectorAll(".variant-chooser");

  allVariantSelects.forEach((variantSelect) => {
    const variantId = variantSelect.value;
    const productId = variantSelect.id.split("variant")[1];
    const variantDescription = variantSelect.querySelector(
      `option[value="${variantId}"]`
    ).dataset.description;

    const variantAmount = variantSelect.querySelector(
      `option[value="${variantId}"`
    ).dataset.amount;

    const variantKilo = variantSelect.querySelector(
      `option[value="${variantId}"`
    ).dataset.kilo;

    // set the title and color on the swatch
    const variantColor = variantSelect.querySelector(
      `option[value="${variantId}"]`
    ).dataset.color;

    const variantTitle = variantSelect.querySelector(
      `option[value="${variantId}"]`
    ).dataset.title;

    if (variantTitle) {
      variantSelect.nextElementSibling.innerHTML = variantTitle;
      variantSelect.nextElementSibling.style.backgroundColor = variantColor;
    }

    if (variantDescription && variantAmount) {
      document.getElementById("product-info-" + productId).innerHTML = (
        "(" +
        variantAmount +
        " stuks " +
        variantDescription +
        " " +
        variantKilo +
        ")"
      ).replace(" )", ")");
    } else {
      document.getElementById("product-info-" + productId).innerHTML = "";
    }
  });
};

const allVariantSelectsToAddClick =
  document.querySelectorAll(".variant-chooser");

allVariantSelectsToAddClick.forEach((variantSelect) => {
  variantSelect.addEventListener("change", setDescriptions);
});
setDescriptions();

clickOnDiaperSubscription();

const allButtons = document.querySelectorAll(".sizeChooser button");
allButtons.forEach((b) => {
  b.addEventListener("click", clickOnDiaperSubscription);
});

// fill in page 1 if localhost
if (window.location.hostname === "127.0.0.1") {
  const childName = document.getElementById("childName");
  const childImage = document.querySelector(".child-selector li.active img");
  const dateOfBirth = document.getElementById("dateOfBirth");
  const postcode = document.getElementById("zip");

  if (childName && childImage && dateOfBirth && postcode) {
    childName.value = "Mila";
    dateOfBirth.value = "2021-01-01";
    postcode.value = "8000";
  }
  showConfigurator();
}

const nextChildButton = document.querySelector(".nextChild");
if (nextChildButton) {
  nextChildButton.addEventListener("click", () => {
    // scroll UL to next child
    const activeChild = document.querySelector(".child-selector li.active");
    const nextChild = activeChild.nextElementSibling;
    if (nextChild) {
      activeChild.classList.remove("active");
      nextChild.classList.add("active");
      nextChild.scrollIntoView({
        behavior: "smooth",
        block: "center",
        inline: "center",
      });
    } else {
      // scroll to first child in list
      activeChild.classList.remove("active");

      const firstChild = document.querySelector(".child-selector li");
      firstChild.classList.add("active");
      firstChild.scrollIntoView({
        behavior: "smooth",
        block: "center",
        inline: "center",
      });
    }
  });
}

const previousChildButton = document.querySelector(".previousChild");
if (previousChildButton) {
  previousChildButton.addEventListener("click", () => {
    // scroll UL to next child
    const activeChild = document.querySelector(".child-selector li.active");
    const nextChild = activeChild.previousElementSibling;
    if (nextChild) {
      activeChild.classList.remove("active");
      nextChild.classList.add("active");
      nextChild.scrollIntoView({
        behavior: "smooth",
        block: "center",
        inline: "center",
      });
    } else {
      // scroll to first child in list
      activeChild.classList.remove("active");

      const lastChild = document.querySelector(".child-selector li:last-child");
      lastChild.classList.add("active");
      lastChild.scrollIntoView({
        behavior: "smooth",
        block: "center",
        inline: "center",
      });
    }
  });
}

const nextSizeButton = document.querySelector(".nextSize");
if (nextSizeButton) {
  nextSizeButton.addEventListener("click", () => {
    // scroll UL to next child
    const activeSize = document.querySelector(".sizeChooser .size.active");
    const nextSize =
      activeSize.parentElement.nextElementSibling?.querySelector(".size");
    if (nextSize) {
      activeSize.classList.remove("active");
      nextSize.classList.add("active");
      // scroll nextSize into view
      activeSize.parentElement.parentElement.scrollLeft += nextSize.offsetLeft;
    } else {
      // scroll to first child in list
      activeSize.classList.remove("active");

      const firstSize =
        activeSize.parentElement.parentElement.querySelector(".size");
      firstSize.classList.add("active");
      activeSize.parentElement.parentElement.scrollLeft = 0;
    }
  });
}

const previousSizeButton = document.querySelector(".previousSize");
if (previousSizeButton) {
  previousSizeButton.addEventListener("click", () => {
    // scroll UL to next child
    const activeSize = document.querySelector(".sizeChooser .size.active");
    const previousSize =
      activeSize.parentElement.previousElementSibling?.querySelector(".size");
    if (previousSize) {
      activeSize.classList.remove("active");
      previousSize.classList.add("active");
      // scroll nextSize into view
      activeSize.parentElement.parentElement.scrollLeft -=
        previousSize.offsetLeft;
    } else {
      // scroll to first child in list
      activeSize.classList.remove("active");

      const lastSize = activeSize.parentElement.parentElement.querySelector(
        "li:last-child .size"
      );
      lastSize.classList.add("active");
      activeSize.parentElement.parentElement.scrollLeft = lastSize.offsetLeft;
    }
  });
}

if (this.location.hash.includes("#configurator")) {
  // remove this hash from url
  this.location.hash = "";
  showConfigurator();
}
